var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServices3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 22",
    style: {
      enableBackground: "new 0 0 22 22"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\t.st0{fill:#73BE2F;}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.5,4.7c-0.4,0-0.7,0.1-1.1,0.2c0-0.2,0.1-0.5,0.1-0.7c0-1.9-1.6-3.5-3.5-3.5c-1.3,0-2.4,0.7-3,1.7 c-0.6-1-1.7-1.7-3-1.7c-1.9,0-3.5,1.6-3.5,3.5c0,0.2,0,0.5,0.1,0.7C4.3,4.7,3.9,4.7,3.5,4.7c-1.9,0-3.5,1.6-3.5,3.5s1.6,3.5,3.5,3.5 S7,10.1,7,8.2C7,8,7,7.7,7,7.5C7.3,7.6,7.6,7.7,8,7.7c1.3,0,2.4-0.7,3-1.7c0.6,1,1.7,1.7,3,1.7c0.4,0,0.7-0.1,1.1-0.2 C15,7.7,15,8,15,8.2c0,1.9,1.6,3.5,3.5,3.5c1.9,0,3.5-1.6,3.5-3.5S20.4,4.7,18.5,4.7z M3.5,9.7C2.7,9.7,2.1,9,2.1,8.2 s0.7-1.5,1.5-1.5C4.4,6.7,5,7.4,5,8.2S4.4,9.7,3.5,9.7z M8,5.7C7.2,5.7,6.5,5,6.5,4.1S7.2,2.6,8,2.6c0.8,0,1.5,0.7,1.5,1.5 S8.8,5.7,8,5.7z M14,5.7c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5S14.8,5.7,14,5.7z M18.5,9.7C17.6,9.7,17,9,17,8.2 s0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5S19.3,9.7,18.5,9.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.1,13l-0.9-1.1c-0.5-0.6-1-1.2-1.6-1.9c-0.7-0.8-1.4-1.4-2.2-1.6c-0.2-0.1-0.3-0.1-0.5-0.1 c-0.7-0.1-1.2-0.1-1.9,0c-0.2,0-0.3,0.1-0.5,0.1c-1,0.3-1.7,1.1-2.2,1.6l-0.9,1.1c-0.5,0.6-1,1.2-1.6,1.9c0,0,0,0.1-0.1,0.1 c-1.7,2.5-1.4,4.3-0.8,5.4c1,1.9,3.5,2.9,6.8,2.9h0.2c3.2,0,5.9-1.2,6.9-3.2C18.4,17.3,18.9,15.5,17.1,13C17.1,13,17.1,13,17.1,13z  M16.2,17.3c-0.6,1.3-2.6,2.1-5.1,2.1h-0.2c-2.5,0-4.4-0.7-5.1-1.9c-0.6-1,0-2.3,0.6-3.3C7,13.6,7.5,13,8,12.4l0.9-1.1 c0.5-0.6,0.9-0.9,1.3-1c0.1,0,0.1,0,0.2,0c0.2,0,0.4,0,0.6,0c0.2,0,0.4,0,0.6,0c0.1,0,0.1,0,0.2,0.1c0.4,0.1,0.8,0.5,1.3,1 c0.6,0.7,1.1,1.3,1.6,1.9l0.9,1.1C16.1,15.1,16.7,16.2,16.2,17.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices3);
export default __webpack_public_path__ + "static/media/services3.55ffe34a0ddbb10bd5291b1d80037195.svg";
export { ForwardRef as ReactComponent };